const AUTH_REDIRECT_RESULT_PATHS = new Set(['/login', '/signup']);

export function shouldResolveAuthRedirect(pathname: string): boolean {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return AUTH_REDIRECT_RESULT_PATHS.has(normalizedPath);
}
